<template>
  <v-container>
    <v-btn-toggle tile v-model="selectedSchicht" class="d-flex flex-row pb-0 mb-0 bg-grey-lighten-2">
      <v-btn class="flex-1-0-0" :variant="getVariant('frueh')" base-color="orange"  value="frueh">Früh</v-btn>
      <v-btn class="flex-1-0-0" :variant="getVariant('mittel')" base-color="pink"  value="mittel">Mittel</v-btn>
      <v-btn class="flex-1-0-0" :variant="getVariant('spaet')" base-color="purple"  value="spaet">Spät</v-btn>
    </v-btn-toggle>
    <v-btn-toggle tile v-model="selectedSchicht" class="d-flex flex-row mb-0 mt-0 pt-0 bg-grey-lighten-2">
      <v-btn class="flex-1-0-0" :variant="getVariant('ne')" base-color="blue"  value="ne">NE</v-btn>
<!--      <v-btn class="flex-1-0-0" :variant="getVariant('geteilt')" base-color="teal"  value="geteilt">Geteilt</v-btn>-->
      <v-btn class="flex-1-0-0" :variant="getVariant('frei')" base-color="green"  value="frei">Frei</v-btn>
    </v-btn-toggle>
  </v-container>
</template>

<script>
import { ref, watch } from "vue";

export default {
  setup(props, { emit }) {
    const selectedSchicht = ref('');
    
    const getVariant = (value) => {
      return selectedSchicht.value === value ? "flat" : "plain";
    };

    watch(selectedSchicht, (newValue) => {
      emit("schicht-selected", newValue);
    });

    return { selectedSchicht, getVariant };
  }
};
</script>